import { Link } from "react-router-dom";
import { channelCategories } from "@/mocks/channels";

export default function ChannelQuickEntry() {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-12 md:px-6 md:py-16">
        <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="mb-2 inline-flex items-center gap-1.5 text-xs font-label font-semibold uppercase tracking-[0.2em] text-primary-400">
              <span className="h-3 w-1 rounded-full bg-primary-500" />
              Channels
            </span>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              热门频道快捷入口
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              三大核心频道，覆盖赛事、音乐、美食与更多精彩内容
            </p>
          </div>
          <Link
            to="/channels"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-300 transition-colors hover:text-primary-200"
          >
            查看全部频道
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {channelCategories.map((channel) => (
            <Link
              key={channel.key}
              to={`/channels?category=${channel.key}`}
              className="group relative flex h-56 flex-col justify-end overflow-hidden rounded-lg border border-background-200/60 transition-colors hover:border-primary-500/60 sm:h-64"
            >
              <img
                src={channel.cover}
                alt={`${channel.name}直播频道`}
                title={`${channel.name}直播 - 360直播`}
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/50 to-transparent" />
              <div className="relative p-5">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className={`${channel.icon} text-xl`} />
                </span>
                <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950">
                  {channel.name}直播
                </h3>
                <p className="mt-1 text-xs leading-relaxed text-foreground-600">{channel.desc}</p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                    <span className="h-1.5 w-1.5 rounded-full bg-accent-400 animate-live-pulse" />
                    {channel.liveCount} 个直播中
                  </span>
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50/70 text-foreground-900 backdrop-blur-sm transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}